import { defineMessages } from 'react-intl';

export default defineMessages({
  worryFreeGuarantee: {
    id: 'CheckoutGuaranties.worryFreeGuarantee',
    description: 'Title for Worry Free Guarantee',
    defaultMessage: 'Worry-Free Guarantee',
  },
  worryFreeMattressGuarantee: {
    id: 'CheckoutGuaranties.worryFreeMattressGuarantee',
    description: 'Title for Worry Free Mattress Guarantee',
    defaultMessage: 'Worry-Free Mattress Guarantee',
  },
});
